const nannyCaretakerService = {
  title: "Nanny / Care-taker",
  icon: "🧸",
  rateCardKey: "nanny-caretaker",
  shortDescription:
    "Child care, elder companionship support, and basic at-home care assistance.",
  longDescription:
    "Book child supervision or non-medical care support for home assistance, companionship, and routine supervision needs.",
  consultationNote:
    "Medical patient care, newborn specialization, or 24-hour care should begin with stricter verification and scope review.",
  responsePromise:
    "Assignment depends on hours, locality, care type, and trust checks.",
  warrantyPolicy:
    "Service quality depends on care requirements, home environment, and task boundaries.",
  subServices: [
    {
      id: "nanny-babysitting-4hr",
      title: "Baby / Child Sitting - 4 Hours",
      icon: "👶",
      group: "Child Care",
      description:
        "Short childcare support for supervision and basic assistance.",
      basePrice: 699,
      priceType: "starts_at",
      duration: "4 hrs",
      warranty: "Visit completion only",
      unit: "shift",
    },
    {
      id: "nanny-full-day",
      title: "Child Care - Full Day",
      icon: "🧸",
      group: "Child Care",
      description:
        "Day-based child care assistance within agreed household scope.",
      basePrice: 1499,
      priceType: "starts_at",
      duration: "8-9 hrs",
      warranty: "Visit completion only",
      unit: "shift",
    },
    {
      id: "caretaker-elder-visit",
      title: "Elder Care Visit Support",
      icon: "🫶",
      group: "Care Support",
      description:
        "Non-medical support for companionship and basic routine assistance.",
      basePrice: 799,
      priceType: "starts_at",
      duration: "3-4 hrs",
      warranty: "Visit completion only",
      unit: "visit",
    },
    {
      id: "caretaker-recurring-consult",
      title: "Recurring Care Requirement Consultation",
      icon: "📋",
      group: "Consultation",
      description:
        "Consultation to understand home care schedule, hours, and support scope.",
      basePrice: 299,
      priceType: "inspection",
      duration: "20-30 mins",
      warranty: "Consultation only",
      unit: "consult",
    },
  ],
};

export default nannyCaretakerService;